export const styles = {
  '@global': {
    '.ag-popup > div': {
      boxShadow: 'none',
    },
  },
  container: {
    position: 'absolute' as const,
    display: 'inline-block',
  },
  paper: {
    display: 'inline-block',
  },
};
